var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"description":"已提交，请在设备上继续下一步操作"}})}
var staticRenderFns = []

export { render, staticRenderFns }